import axios from "axios";

const getTagDetail = (uuid) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/serialnumber/api/v1/tag/${uuid}/detail`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getTagDetail;
